/**
 * The Redux store.
 *
 * Holds two slices and nothing else: `auth` (session and permissions, needed
 * synchronously during render) and `ui` (sidebar, toasts). Every other piece of
 * server state belongs to TanStack Query — see `src/app/queryClient.js`.
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice.js';
import uiReducer from '../features/ui/uiSlice.js';

export const store = configureStore({
  reducer: { auth: authReducer, ui: uiReducer },
});
